module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-up--.56c0d3ca.svg";